export const FEEDBACK_LABEL = 'Share feedback';
export const FOLLOW_UP_LABEL = 'Follow up actions';
export const RATING_SCORES = [
  // Bad rating
  1,
  // Good rating
  5,
];
